export default {
  methods: {
    updateQuery(obj) {
      const query = this.$route.query
      this.$router.push({ query: { ...query, ...obj } })
    },
  },
}
